import { render, staticRenderFns } from "./draggable-list-item.vue?vue&type=template&id=24ac08a9&scoped=true&"
import script from "./draggable-list-item.vue?vue&type=script&lang=js&"
export * from "./draggable-list-item.vue?vue&type=script&lang=js&"
import style0 from "./draggable-list-item.vue?vue&type=style&index=0&id=24ac08a9&scoped=true&lang=scss&"
import style1 from "./draggable-list-item.vue?vue&type=style&index=1&id=24ac08a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ac08a9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VIcon,VSheet})
